export const REFIL_EVEREST_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@id": "https://everest.ind.br/#organization",
   "@type": "Organization",
   "name": "Everest",
   "url": "https://everest.ind.br",
   "logo": {
    "@type": "ImageObject",
    "url": "https://www.everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/refil-original-everest#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Produtos",
     "item": "https://everest.ind.br/pt/produto"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Refil Original Everest",
     "item": "https://everest.ind.br/pt/refil-original-everest"
    }
   ]
  },
  {
   "@type": "Product",
   "@id": "https://everest.ind.br/pt/refil-original-everest#product",
   "name": "Refil Original Everest",
   "description": "Elemento filtrante 2 em 1 desenvolvido exclusivamente para os purificadores da linha Everest (Baby, Fit, Slim, Star e Plus). Combina pré-filtragem com polipropileno Melt Blown (retenção de partículas acima de 5 micra) e filtragem com carvão ativado impregnado com prata coloidal para redução de cloro, odores e sabores indesejados. Certificado ABRAFIPA.",
   "url": "https://www.everest.ind.br/pt/refil-original-everest",
   "image": [
    "https://assets.everest.ind.br/images/Group_37705_1.original_1.original.png"
   ],
   "brand": {
    "@type": "Brand",
    "name": "Everest"
   },
   "manufacturer": {
    "@id": "https://everest.ind.br/#organization"
   },
   "model": "Refil Original Everest 2 em 1",
   "mpn": "REFIL-EVEREST-2EM1",
   "category": "Casa > Purificador de Água > Filtro de Água",
   "material": "Polipropileno, Carvão ativado vegetal (coco de Babaçu) com prata coloidal",
   "isAccessoryOrSparePartFor": [
    {
     "@type": "Product",
     "@id": "https://everest.ind.br/pt/produto/everest-baby#product",
     "name": "Purificador de Água Everest Baby"
    },
    {
     "@type": "Product",
     "@id": "https://everest.ind.br/pt/produto/everest-fit#product",
     "name": "Purificador de Água Everest Fit"
    },
    {
     "@type": "Product",
     "@id": "https://everest.ind.br/pt/produto/everest-slim#product",
     "name": "Purificador de Água Everest Slim"
    },
    {
     "@type": "Product",
     "@id": "https://everest.ind.br/pt/produto/everest-star#product",
     "name": "Purificador de Água Everest Star"
    },
    {
     "@type": "Product",
     "@id": "https://everest.ind.br/pt/produto/everest-plus#product",
     "name": "Purificador de Água Everest Plus"
    }
   ],
   "additionalProperty": [
    {
     "@type": "PropertyValue",
     "name": "Vida útil",
     "value": "4.000 litros (9 a 12 meses)"
    },
    {
     "@type": "PropertyValue",
     "name": "Vazão máxima",
     "value": "0,75 litros/minuto"
    },
    {
     "@type": "PropertyValue",
     "name": "Pressão máxima",
     "value": "0,392 MPa (40 MCA)"
    },
    {
     "@type": "PropertyValue",
     "name": "Etapas de filtração",
     "value": "2 etapas: pré-filtragem (polipropileno Melt Blown, partículas > 5 micra) + carvão ativado com prata coloidal"
    },
    {
     "@type": "PropertyValue",
     "name": "Certificação",
     "value": "ABRAFIPA (Certificado nº 08672/2021), INMETRO"
    },
    {
     "@type": "PropertyValue",
     "name": "Altura",
     "value": "241 mm"
    },
    {
     "@type": "PropertyValue",
     "name": "Diâmetro",
     "value": "78,5 mm"
    },
    {
     "@type": "PropertyValue",
     "name": "Peso",
     "value": "0,342 kg"
    },
    {
     "@type": "PropertyValue",
     "name": "Compatibilidade",
     "value": "Todos os modelos Everest: Baby, Fit, Slim, Star e Plus"
    }
   ],
   "offers": {
    "@type": "Offer",
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock",
    "url": "https://www.everest.ind.br/pt/refil-original-everest",
    "seller": {
     "@id": "https://everest.ind.br/#organization"
    }
   },
   "potentialAction": {
    "@type": "ViewAction",
    "target": "https://www.everest.ind.br/pt/refil-original-everest"
   }
  }
 ]
}
